import { BusinessProfile } from '@iot-platform/models/common';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { AdminBusinessProfilesActions } from '../../../admin-business-profiles/state/actions/business-profiles.actions';
import { AdminOrganizationsBusinessProfilesApiActions } from '../actions';

export const adminOrganizationsBusinessProfilesApiFeatureKey = 'adminOrganizationsBusinessProfilesApi';

export interface State extends EntityState<BusinessProfile> {
  selectedBusinessProfileId: string | null;
}

export const adapter: EntityAdapter<BusinessProfile> = createEntityAdapter<BusinessProfile>({
  selectId: (businessProfile: BusinessProfile) => businessProfile.id,
  sortComparer: false
});

export const initialState: State = adapter.getInitialState({
  selectedBusinessProfileId: null
});

export const reducer = createReducer(
  initialState,
  on(AdminOrganizationsBusinessProfilesApiActions.listBusinessProfilesByOrganizationSuccess, (state: State, { businessProfiles }) =>
    adapter.setAll(businessProfiles, state)
  ),
  on(AdminOrganizationsBusinessProfilesApiActions.listBusinessProfilesByOrganizationFailure, (state: State, { error }) => ({ ...state, error })),
  on(AdminBusinessProfilesActions.addOneSuccess, (state: State, { added }) => adapter.addOne(added, state)),
  on(AdminBusinessProfilesActions.updateOneSuccess, (state: State, { updated }) =>
    adapter.updateOne(
      {
        id: updated.id,
        changes: updated
      },
      state
    )
  ),
  on(AdminBusinessProfilesActions.deleteOneSuccess, (state: State, { deleted }) => adapter.removeOne(deleted.id, state))
);

export const getSelectedId = (state: State) => state.selectedBusinessProfileId;
